import debounce from 'lodash/debounce';
import { component } from 'picoapp';

export default component((node) => {
  const { sizeValues } = node.dataset;

  const changeStyles = debounce(() => {
    const valueWrappers = node.querySelectorAll(
      '.yotpo .product-related-fields-item[data-type="Size"] .product-related-fields-item-value:not(.updated)',
    );

    if (!valueWrappers.length) return;

    valueWrappers.forEach((valueWrapper) => {
      const { innerText: activeValue } = valueWrapper;
      const styledValues = sizeValues.replace(
        activeValue.trim(),
        `<strong style="color: #0055FF;">${activeValue}</strong>`,
      );

      valueWrapper.innerHTML = styledValues;
      valueWrapper.classList.add('updated');
    });
  }, 50);

  const scrollToTop = debounce((event) => {
    const { target } = event;

    if (
      target.matches('.yotpo-page-element:not([aria-current="true"]):not([aria-disabled="true"])')
    )
      window.scrollTo({
        top: node.offsetTop,
        behavior: 'instant',
      });
  }, 200);

  if (!node.querySelector('.main-widget')) {
    const reviewsMutationObserver = new MutationObserver(([entry]) => {
      entry.addedNodes.forEach((addedNode) => {
        if (addedNode.nodeType === Node.ELEMENT_NODE && addedNode?.closest('.main-widget')) {
          changeStyles();
        }
      });
    });

    reviewsMutationObserver.observe(node, { childList: true, subtree: true });
  } else {
    changeStyles();
  }

  node.addEventListener('click', scrollToTop);
});
